import { render, staticRenderFns } from "./ModerateImages.vue?vue&type=template&id=f4fbacdc&scoped=true&"
import script from "./ModerateImages.vue?vue&type=script&lang=js&"
export * from "./ModerateImages.vue?vue&type=script&lang=js&"
import style0 from "./ModerateImages.vue?vue&type=style&index=0&id=f4fbacdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fbacdc",
  null
  
)

export default component.exports